module.exports = __webpack_public_path__ + "static/media/test.51029baf.pdf";